import React from "react";

const SendIconV216pxSvg = ({
    color = "#1F2937",
    width = 20,
    height = 20,
    ...props
}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M9.48025 14.4196C8.69358 14.4196 7.58025 13.8662 6.70025 11.2196L6.22025 9.77956L4.78025 9.29956C2.14025 8.41956 1.58691 7.30623 1.58691 6.51956C1.58691 5.73956 2.14025 4.61956 4.78025 3.73289L10.4402 1.84623C11.8536 1.37289 13.0336 1.51289 13.7602 2.23289C14.4869 2.95289 14.6269 4.13956 14.1536 5.55289L12.2669 11.2129C11.3802 13.8662 10.2669 14.4196 9.48025 14.4196ZM5.09358 4.68623C3.24025 5.30623 2.58025 6.03956 2.58025 6.51956C2.58025 6.99956 3.24025 7.73289 5.09358 8.34623L6.77358 8.90623C6.92025 8.95289 7.04025 9.07289 7.08691 9.21956L7.64691 10.8996C8.26025 12.7529 9.00025 13.4129 9.48025 13.4129C9.96025 13.4129 10.6936 12.7529 11.3136 10.8996L13.2002 5.23956C13.5402 4.21289 13.4802 3.37289 13.0469 2.93956C12.6136 2.50623 11.7736 2.45289 10.7536 2.79289L5.09358 4.68623Z" fill={color} />
            <path d="M6.73954 9.60065C6.61288 9.60065 6.48621 9.55398 6.38621 9.45398C6.19288 9.26065 6.19288 8.94065 6.38621 8.74732L8.77288 6.35398C8.96621 6.16065 9.28621 6.16065 9.47954 6.35398C9.67288 6.54732 9.67288 6.86732 9.47954 7.06065L7.09288 9.45398C6.99954 9.55398 6.86621 9.60065 6.73954 9.60065Z" fill={color} />
        </svg>

    );
};

export default SendIconV216pxSvg;